import React, { useContext } from 'react';
import { Grid, Paper, Typography, useTheme, Chip, Box } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import DeliveryDining from '@mui/icons-material/DeliveryDining';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Alert, AlertTitle } from '@mui/material';
import { generateWhatsAppLink } from '../driver-order-lookup/utils';
import { CheckCircle, WhatsApp } from '@mui/icons-material';
import { User } from '../../../interfaces/common/authentication';
import { AuthContext } from '../../../contexts/user-context/user-context';
import ErrorIcon from '@mui/icons-material/Error';

interface MenuDefinitionItem {
  name: string;
  icon: React.ReactNode;
  route_substring: string;
  route: string;
}

const driver_menu_definition = (user: User): MenuDefinitionItem[] => [
  {
    name: 'Pickup Tasks',
    icon: <InboxIcon />,
    route_substring: 'pickup-tasks',
    route: 'pickup-tasks',
  },
  {
    name: 'Delivery Tasks',
    icon: <DeliveryDining />,
    route_substring: 'delivery-batches',
    route: 'delivery-batches',
  },
  {
    name: 'Payment Tasks',
    icon: <AttachMoneyIcon />,
    route_substring: 'payment-tasks',
    route: 'payment-tasks',
  },
  {
    name: 'My Invoices',
    icon: <ReceiptIcon />,
    route_substring: 'invoice',
    route: 'invoices',
  },
  {
    name: 'Profile',
    icon: <AccountCircleIcon />,
    route_substring: 'profile',
    route: 'profile',
  },
  {
    name: 'Connection',
    icon: <WhatsApp />,
    route_substring: 'whatsapp',
    route: 'whatsapp',
  },
];

const DriverMenu: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { user, config } = useContext(AuthContext);

  return (
    <>
      <Grid
        container
        spacing={2}
        padding={2}
        sx={{ backgroundColor: 'transparent' }}
      >
        {driver_menu_definition(user!).map((item, index) => {
          const isConnectionItem = item.route_substring === 'whatsapp';
          return (
            <Grid item xs={6} key={index}>
              <Paper
                elevation={2}
                sx={{
                  p: 2,
                  height: 100,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  borderRadius: 2,
                  transition: 'all 0.2s ease',
                  position: 'relative',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: theme.shadows[4],
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
                onClick={() => navigate(`/${item.route}`)}
              >
                {React.cloneElement(item.icon as React.ReactElement, {
                  sx: {
                    color: theme.palette.primary.main,
                    fontSize: '2rem',
                  },
                })}
                <Typography
                  variant="subtitle1"
                  align="center"
                  sx={{
                    mt: 1,
                    fontWeight: 500,
                  }}
                >
                  {item.name}
                </Typography>

                {/* Tiny Status Icon - only for the Connection card */}
                {isConnectionItem &&
                  user?.connected_to_whatsapp !== undefined && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 6,
                        right: 6,
                      }}
                    >
                      {user.connected_to_whatsapp ? (
                        <CheckCircle
                          sx={{ color: 'green', fontSize: '1.2rem' }}
                        />
                      ) : (
                        <ErrorIcon sx={{ color: 'red', fontSize: '1.2rem' }} />
                      )}
                    </Box>
                  )}
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default DriverMenu;
